import { colors } from '../../../theme/colors'

export const ChartGridConstants = {
  stroke: colors.chart.gridStroke,
  strokeDasharray: '2 2',
  strokeWidth: 1,
  defaultShowYGridlines: true,
  defaultShowXGridlines: false,
}

export const ChartGridStyles = {
  stroke: ChartGridConstants.stroke,
  strokeDasharray: ChartGridConstants.strokeDasharray,
  strokeWidth: ChartGridConstants.strokeWidth,
}
